<template>
  <div class="tabs">
    <button
      v-for="(tab, idx) in tabs"
      :id="`tab-${tab.id}`"
      :key="idx"
      class="tab"
      :class="{ tab_selected: currentId === tab.id }"
      @click="$emit('change', tab.id)"
    >
      <template v-if="tab.main && tab.main === true">
        <span class="tab__title">{{ tab.title }}</span>
      </template>
      <template v-else>
        <span class="tab__index">{{ tab.order + 1 }}</span>
        <span class="tab__title">{{ tab.title }}</span>
        <span v-show="tab.count" class="tab__counter">
          {{ tab.count }}
        </span>
      </template>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'Tabs',
    model: {
      prop: 'currentId',
      event: 'change',
    },
    props: {
      currentId: {
        type: Number,
        required: true,
      },
      tabs: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/colors';

  .tab {
    transition: background-color 0.2s ease;
    background: $grey100;
    outline: none;
    border-radius: 8px 8px 0 0;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 8px 12px;

    margin: 0 8px 0 0;
    white-space: nowrap;

    &_selected {
      background: white;
    }
  }

  .tabs {
    overflow-x: scroll;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 20px 0 20px;
    background-color: $grey50;
  }

  .tab_selected .tab__title {
    color: $grey900;
  }

  .tab__index {
    color: $grey500;
    font-weight: 500;
    font-size: 14px;
    margin: 0 4px 0 0;
  }

  .tab__title {
    color: $grey600;
    font-size: 14px;
    font-weight: 500;
    margin: 0;
  }

  .tab__counter {
    background: $info600;
    border-radius: 4px;
    color: white;
    padding: 0 6px;
    margin-left: 4px;
  }
</style>
